// removed by extract-text-webpack-plugin
module.exports = {"page-sidebar":"page-sidebar","page-sidebar__left":"page-sidebar__left","page-sidebar__right":"page-sidebar__right","breadcrumbs":"breadcrumbs","left-menu":"left-menu","left-menu__item":"left-menu__item","left-menu__link":"left-menu__link","active":"active","submenu":"submenu","submenu__item":"submenu__item","submenu__link":"submenu__link","sub-submenu":"sub-submenu","sub-submenu__item":"sub-submenu__item","sub-submenu__link":"sub-submenu__link"};


//////////////////
// WEBPACK FOOTER
// ../css/components/_page-sidebar.scss
// module id = 90
// module chunks = 0